<template>
  <div class="canvassListPage">
    <XR-head titleText="微信支付" :rightShow="false"></XR-head>    
    {{orderNo}}
    {{openId}}
    <mu-flat-button @click="weixinPay">微信支付</mu-flat-button>
    <mu-flat-button @click="weixinPay2">微信支付2</mu-flat-button>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import wechatCache from '../../../util/wechatCache'
export default {
  data(){
    return {   
      orderNo:'',
      openId: ''
    }
  },
  mounted(){
    this.getUserInfo()
  },
  methods:{
    getUserInfo(){
      this.orderNo = window.localStorage.OrderPayNo
      if(!this.orderNo){
        ths.$refs.XRtoast.failed('请重新下单', true)
        return
      }
      this.openId = wechatCache.getOpenId()
      if(!this.openId){
        ths.$refs.XRtoast.failed('未获取微信信息', true)
        return
      }
      
      var ths = this;   
      ths.$post(
        "/Shop/WeChatServer/GetWeChatPay",
        {openId:this.openId,orderNo:this.orderNo}
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.loaded=false             
          ths.$refs.XRtoast.hide()
          ths.weixinPay2(res.Data)
        }
      });
    },
    weixinPay:function(data){
      var vm= this;
      if (typeof WeixinJSBridge == "undefined"){//微信浏览器内置对象。参考微信官方文档
        if( document.addEventListener ){
          document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(data), false);
        }else if (document.attachEvent){
          document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(data));
          document.attachEvent('onWeixinJSBridgeReady',vm.onBridgeReady(data));
        }
      }else{
        vm.onBridgeReady(data);
      }
    },
    onBridgeReady:function(data){
      var  vm = this;
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',{
          debug:true,
          "appId":data.AppId,     //公众号名称，由商户传入
          "timeStamp":data.TimeStamp, //时间戳，自1970年以来的秒数
          "nonceStr":data.NonceStr, //随机串
          "package":data.Package,
          "signType":data.SignType, //微信签名方式：
          "paySign":data.PaySign, //微信签名
          //这里的信息从后台返回的接口获得。
          jsApiList: [
            'chooseWXPay'
          ]
        },
        function(res){
          // 使用以上方式判断前端返回,微信郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          if(res.err_msg == "get_brand_wcpay_request:ok" ){
            if(vm.fromRoute == 'personal'){
              window.location.href = vm.BASE_URL + 'index.html#/depositResult'
            }else {
              vm.confirmTry();
            }
          }else{
            alert("取消支付！");
          }
        }
      );
    },
    weixinPay2:function(data){
      WeixinJSBridge.invoke('getBrandWCPayRequest', {
         "appId":data.AppId,     //公众号名称，由商户传入
          "timeStamp":data.TimeStamp, //时间戳，自1970年以来的秒数
          "nonceStr":data.NonceStr, //随机串
          "package":data.Package,
          "signType":data.SignType, //微信签名方式：
          "paySign":data.PaySign, //微信签名
        },
        function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
                alert("微信支付成功!");
                window.location.href = "/Cart/OrderPaySuccess.aspx?orderId=<%=OrderSN %>";
            } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
                alert("用户取消支付!");
            } else {
                alert(res.err_msg);
                alert("支付失败!");
            }
            // 使用以上方式判断前端返回,微信郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            //因此微信建议，当收到ok返回时，向商户后台询问是否收到交易成功的通知，若收到通知，前端展示交易成功的界面；若此时未收到通知，商户后台主动调用查询订单接口，查询订单的当前状态，并反馈给前端展示相应的界面。
        }
      );
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/retail/pay/alipayGo.vue